const DeleteCazaAttempt = async (idAttempt: string) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/caza/attempt/${idAttempt}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        console.error('Error deleting attempt:', error);
        throw error;
    }
}

export { DeleteCazaAttempt };
